import { BulkCreateTabFeature } from "./BulkCreateTabFeature";

export default BulkCreateTabFeature;
